<div id="invoice-preview-and-configuration-panel" class="k-d-flex">
  <div id="invoice-preview">
    <app-invoice-preview [mode]="mode()" />
  </div>

  <div id="configuration-panel" class="k-pos-sticky k-top-0 k-h-full">
    <app-edit-document-section-base-data />
    <app-edit-document-section-base-styling />
    <app-edit-document-section-handling />
    @switch (type()) {
      @case (SectionType.Image) {
        <app-edit-document-section-image-upload />
      }

      @case (SectionType.HTML) {
        <app-edit-document-section-wysiwyg />
      }
    }
  </div>
</div>
